import { ConversationStep, Theme } from "../../interfaces";
import AppointmentSteps from "../AppointmentSteps";
import { getApplicantSteps } from "../ApplicantSteps";
import EscalationSteps from "../EscalationSteps";

const GeneralInsuranceSteps = (theme: Theme) => {
  return [
    {
      id: "1",
      type: "bot",
      message: "Hey, I'm Parker - The Insurance Assistant",
      trigger: "2",
    },
    {
      id: "2",
      type: "bot",
      message:
        "My job is to ask you a few questions and get you a insurance quote sorted",
      trigger: "3",
    },
    {
      id: "3",
      type: "bot",
      message: "I just need to ask you 5 questions to do so",
      trigger: "Looking for",
    },
    {
      id: "Looking for",
      type: "bot",
      message: "What are you looking for?",
      options: [
        {
          label: "Not sure",
          value: "Not sure",
          trigger: "Cover cost",
        },
        {
          label: "Building and Contents",
          value: "Building and Contents",
          trigger: "Cover cost",
        },
        {
          label: "Car Insurance",
          value: "Car Insurance",
          trigger: "Cover cost",
        },
        {
          label: "Life Insurance",
          value: "Life Insurance",
          trigger: "Cover cost",
        },
        {
          label: "Rental Cover",
          value: "Rental Cover",
          trigger: "Cover cost",
        },
      ],
    },
    {
      id: "Cover cost",
      type: "bot",
      message: "What sort of cover are you looking for?",
      options: [
        {
          label: "£100k",
          value: "£100k",
          trigger: "Home or rental",
        },
        {
          label: "£200k",
          value: "£200k",
          trigger: "Home or rental",
        },
        {
          label: "£300k",
          value: "£300k",
          trigger: "Home or rental",
        },
        {
          label: "£400k",
          value: "£400k",
          trigger: "Home or rental",
        },
        {
          label: "Not sure",
          value: "Not sure",
          trigger: "Home or rental",
        },
        {
          label: "Over £500k",
          value: "Over £500k",
          trigger: "Home or rental",
        },
      ],
    },
    {
      id: "Home or rental",
      type: "bot",
      message: "Is it your home or a rental?",
      options: [
        {
          label: "We live there",
          value: "We live there",
          trigger: "Budget",
        },
        {
          label: "We rent it out",
          value: "We rent it out",
          trigger: "Budget",
        },
        {
          label: "We are renters",
          value: "We are renters",
          trigger: "Budget",
        },
      ],
    },
    {
      id: "Budget",
      type: "bot",
      message: "Is it your home or a rental?",
      options: [
        {
          label: "£40pm",
          value: "£40pm",
          trigger: "Job",
        },
        {
          label: "£50pm",
          value: "£50pm",
          trigger: "Job",
        },
        {
          label: "£30pm",
          value: "£30pm",
          trigger: "Job",
        },
        {
          label: "£20pm",
          value: "£20pm",
          trigger: "Job",
        },
        {
          label: "Not sure",
          value: "Not sure",
          trigger: "Job",
        },
      ],
    },
    {
      id: "Job",
      type: "bot",
      message: "What do you do for a living?",
      trigger: "applicant1_title",
      input: {
        type: "text",
      },
    },
    ...getApplicantSteps(1),
    {
      id: "when",
      type: "bot",
      message: "When would you like to speak to the team?",
      trigger: "select_date",
    },
    ...AppointmentSteps(theme),
    ...EscalationSteps,
  ] as ConversationStep[];
};

export default GeneralInsuranceSteps;
